const Navigator = (props) => {
  const selectIndicatorClass = () => {
    if (props.SelectedNavTab === "FIRST") {
      return "indicator";
    } else if (props.SelectedNavTab === "SECOND") {
      return "indicator translated";
    } else if (props.SelectedNavTab === "THIRD") {
      return "indicator third-pos";
    } else {
      return "indicator fourth-pos";
    }
  };

  const handleSwitchTab = (Index, Id) => {
    props.SwitchTab(Index, Id);
    props.SetEditUserIsActive(false);
  };

  return (
    <div className="desktop-nav admin-navigator">
      <span className={selectIndicatorClass()}></span>
      <section
        id="first-nav"
        onClick={() => handleSwitchTab("FIRST", "first-nav")}
        className={
          props.SelectedNavTab === "FIRST" ? "nav-row active" : "nav-row"
        }
      >
        <span className="row-icon first-icon"></span>
        <p>User Management</p>
      </section>
      <section
        id="second-nav"
        onClick={() => handleSwitchTab("SECOND", "second-nav")}
        className={
          props.SelectedNavTab === "SECOND" ? "nav-row active" : "nav-row"
        }
      >
        <span className="row-icon second-icon"></span>
        <p>Settings</p>
      </section>
      <section
        id="third-nav"
        onClick={() => handleSwitchTab("THIRD", "third-nav")}
        className={
          props.SelectedNavTab === "THIRD" ? "nav-row active" : "nav-row"
        }
      >
        <span className="row-icon third-icon"></span>
        <p>AI Settings</p>
      </section>
      <section
        id="fourth-nav"
        onClick={() => handleSwitchTab("FOURTH", "fourth-nav")}
        className={
          props.SelectedNavTab === "FOURTH" ? "nav-row active" : "nav-row"
        }
      >
        <span className="row-icon fourth-icon"></span>
        <p>Categories</p>
      </section>
    </div>
  );
};

export default Navigator;
